// Data model interfaces for the Client Entities tab.
// Fields match the API contract (snake_case) from GET /client-entity-allocations.

/** Represents a single entity allocation linked to a client. */
export interface IEntity {
  /** Unique allocation identifier. */
  id: number;
  /** Client ID this allocation belongs to. */
  client_id: number;
  /** Investor/entity ID. */
  investor_id: number;
  /** Human-readable name of the entity (e.g. fund name). */
  investor_name: string;
  /** Vehicle type (e.g. "LP Fund", "SPV"). */
  entity_type: string | null;
  /** Allocation percentage (1–100). */
  allocation_percentage: number;
  /** Number of deals linked to this entity via the client. */
  linked_deals_count: number;
  /** Whether the entity is shared with other clients. */
  is_shared: boolean;
}

/** Props for the inline allocation percentage editor. */
export interface IAllocationCellProps {
  initialValue: number;
  roleId: string | null;
  onUpdate: (newPercentage: number) => void;
  onCancel: () => void;
}

/** Props for the remove-entity confirmation dialog. */
export interface IRemoveEntityDialogProps {
  open: boolean;
  entityName: string;
  linkedDealsCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Allowed edit roles per entity management requirements. */
export const EDIT_ROLES: string[] = ["admin", "team-member"];

/** Props for each row in the ClientEntitiesTable. */
export interface IClientEntitiesTableRowProps {
  entity: IEntity;
  roleId: string | null;
  onAllocationUpdate: (entityId: number, newPercentage: number) => void;
  onRemoveEntity: (entityId: number) => void;
  onEditCancel: () => void;
}
